export const MAX_VISIBLE_COUNT = 99;

/** 0 → "0", 7 → "7", 120 → "99+" */
export const formatCount = (count) => {
  const value = Number(count) || 0;
  return value > MAX_VISIBLE_COUNT ? `${MAX_VISIBLE_COUNT}+` : String(value);
};
